import script from "./MMatching.vue?vue&type=script&setup=true&lang=ts"
export * from "./MMatching.vue?vue&type=script&setup=true&lang=ts"

import "./MMatching.vue?vue&type=style&index=0&id=71aaab7a&lang=less"

const __exports__ = script;

export default __exports__